var render = function render(){var _vm=this,_c=_vm._self._c;return _c('photo-validation-error-modal',{attrs:{"name":"photo-multiple-faces-modal","title":_vm.$t('photoValidation.title.multipleFaces'),"error-message":_vm.$t('photoValidation.text.multipleFaces')}})
}
var staticRenderFns = []

export { render, staticRenderFns }